import Tooltip from "~/ui/tooltip";
import { fragment, node } from "~/util/dom";
import { CONFIG } from "~/config";
import { _ } from "~/i18n";
import Scene from "~/scene";
import MyMapsShare from "~/es6/mymaps.share";
import { htmlToImage } from "~/hti";
import { detect } from "detect-browser";
import { store } from "~/state/store";

export function createVerifiedUserTooltip(anchor: HTMLElement | SVGSVGElement) {
	const frag = fragment();

	frag.appendChild(node("h2", { innerHTML: _("verifiedUserTitle") }));
	frag.appendChild(node("p", { innerHTML: _("verifiedUserText") }));

	return new Tooltip({
		anchor,
		content: frag,
		width: 232,
		margin: [20, 4, 20, 4],
	});
}

/**
 * Pouzije event nad <a> linkem, pokud se jedna o klik ctrl+levy cudl nebo prostredni tlacitko,
 * tak vraci true a otevre odkaz "href" v novem oknevent.
 */
export function linkToNewWindow(event: MouseEvent) {
	if (!event) {
		return false;
	}

	const leftCtrlClick = (event.ctrlKey || event.metaKey) && (event.which === 1 || event.button === 1);
	const middleClick = event.which === 2 || event.button === 4;

	if (middleClick || leftCtrlClick) {
		if (leftCtrlClick) {
			event.stopPropagation();
		}

		return true;
	}

	return false;
}

export function openAdminDetail(source: string, id: number) {
	window.open(`https://admin.mapy.${CONFIG.TLD}/#/base/di/?source=${source}&id=${id}`);
}

/**
 * Podle user-agenta určí, co za systém asi uživatel má a vrátí podle toho "i", "a", "wp" nebo "".
 */
export function getMobileOperatingSystem(): string {
	// @ts-ignore
	const userAgent = navigator.userAgent || navigator.vendor || window.opera;

	// Windows Phone must come first because its UA also contains "Android"
	if (/windows phone/ui.test(userAgent)) {
		return "wp";
	}

	if (/android/ui.test(userAgent)) {
		return "a";
	}

	// iOS detection from: http://stackoverflow.com/a/9039885/177710
	// @ts-ignore
	if (/iPad|iPhone|iPod/u.test(userAgent) && !window.MSStream) {
		return "i";
	}

	return "";
}

export function getRulesLink() {
	const lang = ["cs", "sk", "en", "de", "pl", "it"].indexOf(CONFIG.defaultLang) === -1 ? "en" : CONFIG.defaultLang;

	return `https://licence.mapy.cz/?doc=mapy_pu&lang=${lang}`;
}

export function getHelpLink() {
	const lang = ["cs", "sk", "en", "de", "pl", "it"].indexOf(CONFIG.defaultLang) === -1 ? "en" : CONFIG.defaultLang;

	return `https://help.mapy.com/${lang}/`;
}

export function openOrInstallApplication() {
	const os = getMobileOperatingSystem();

	if (os === "a") {
		window.location.href = CONFIG.android;
	} else if (os === "i") {
		window.location.href = CONFIG.ios;
	} else {
		Mapy.getComponent("mobilepromo").activate();
		Mapy.getComponent("history").save();
	}
}

export function getAttrLink() {
	const lang = ["cs", "sk", "en", "de", "pl", "it"].indexOf(CONFIG.defaultLang) === -1 ? "en" : CONFIG.defaultLang;

	return `https://licence.mapy.cz/?doc=mapy_attr${lang === "cs" ? "" : `&lang=${lang}`}`;
}

export function panoLayerPosition() {
}

export function getNoBoxUrl(url: string): string {
	return url
		.replace("/#!/", "/")
		.replace(/&box=[12]/u, "")
		.replace(/[?]box=[12]&?/u, "?");
}

export function removeMyMapsFromUrl(url: string): string {
	return getNoBoxUrl(url)
		.replace("&cat=mista-trasy", "")
		.replace("&cat=aktivity", "")
		.replace("moje-mapy&", "");
}

export function setProfileDashboardInUrl(reviews = false): string {
	const state = store.getState();
	const { user } = state.user;
	const { longitude, latitude, zoom } = state.map;

	return `${location.protocol}//${CONFIG.BASE_URL}/?up=${user.userPublicId}${reviews ? "&upc=reviews" : ""}&x=${longitude}&y=${latitude}&z=${zoom}`;
}

export function share() {
	let data: {
		[key: string]: any,
	} = {
		title: document.title.split(" • ")[0],
		type: "entity",
	};
	let component = null;
	let componentFc = null;

	let likeData = null;
	// mame nastaveny dim?
	const like = Mapy.getComponent("dimcurator").getState();

	// Znamena ze je otevrena vec z batuzku
	if ("dim" in like) {
		// zkusime nacist likedata
		likeData = Mapy.getComponent("dimcurator").getLikeData();

		// pokud mame prenastavime data
		if (likeData) {
			data = {
				...likeData,
				...{ like: true },
			};

			if (data.owner_name) {
				data.like = false;
			}
		}
	}

	if (Mapy.active[0] === Mapy.getComponent("mymaps")) {
		// aktivni places
		if (Mapy.getComponent("places").isActive) {
			Object.assign(data, Mapy.getComponent("places").shareData);
			data.title = data.usertitle || data.title;

			// aktivni places v rootu, napiseme hlasku o nemoznosti sdileni
			if (data.type === "places-root") {
				data.url = removeMyMapsFromUrl(location.href);
			// aktivni places v detailu slozky, muzeme sdilet
			} else {
				component = Mapy.getComponent("places");
				componentFc = "listRefreshData";

				if (!data.foreign) {
					data.like = true;
				}
			}
		} else if (Mapy.getComponent("activities").isActive) {
			// aktivni detail aktivity, muzeme sdilet - jinak aktivni detail aktivity, ale z places, muzeme sdilet oblibenou
			if (!like.dim) {
				Object.assign(data, Mapy.getComponent("activities").shareData);
				data.title = data.usertitle || data.title;

				// aktivni aktivity, napiseme hlasku o nemoznosti sdileni
				if (data.type === "activities-root") {
					data.url = removeMyMapsFromUrl(location.href);
				} else {
					component = Mapy.getComponent("activities");

					if (!data.foreign) {
						data.like = true;
					}
				}
			}
		} else if (Mapy.getComponent("dashboard").isActive) {
			data.url = setProfileDashboardInUrl();
		} else if (Mapy.getComponent("reviews").isActive) {
			data.url = setProfileDashboardInUrl(true);
		}
	} else if (Mapy.getComponent("places").isActive || Mapy.getComponent("activities").isActive) {
		data.url = removeMyMapsFromUrl(location.href);
	}

	data.showLabel = (Mapy.active[0] === Mapy.getComponent("mymaps") && Mapy.getComponent("places").isActive) || Mapy.active[0] === Mapy.getComponent("userMarks") || Mapy.getComponent("dimcurator").getState().dim;
	data.fromDC = true;

	let sharePopup = new MyMapsShare(data, cbData => {
		if (cbData.name === "popup-close" && data && data.public !== cbData.public && component) {
			component.changePublic(cbData.public);
			if (componentFc) {
				component[componentFc]();
			}
		}

		sharePopup.destroy();
		sharePopup = null;
	});

	sharePopup.open();
}

function prepareImage() {
	return new Promise(resolve => {
		const pano = Mapy.getComponent("pano");

		if (pano.isActive()) {
			const panoCont = pano.getContainer();
			const canvas = panoCont.querySelector("canvas");
			const browser = detect();

			if (browser.name === "safari") {
				const panoState = pano.getState();
				const pitch = panoState.pitch ? `&pitch=${panoState.pitch}` : "";
				const yaw = panoState.yaw ? `&yaw=${panoState.yaw}` : "";
				const src = `//panorama-mapserver.mapy.cz/compose_pano?w=${Math.min(2000, canvas.offsetWidth)}&h=${Math.min(2000, canvas.offsetHeight)}&pid=${panoState.pid}&fov=${panoState.fov}${pitch}${yaw}`;
				const img = node("img", { id: "panoPrintImg", src, width: canvas.offsetWidth, height: canvas.offsetHeight, crossOrigin: "anonymous" });

				img.style.position = "absolute";
				img.style.top = "0";
				img.style.left = "0";

				img.onload = () => {
					resolve({});
				};
				panoCont.insertBefore(img, panoCont.firstChild.nextSibling);
			} else {
				pano.getDataUrl().then(data => {
					if (canvas) {
						const img = node("img", { id: "panoPrintImg", src: data, width: canvas.offsetWidth, height: canvas.offsetHeight });

						img.style.position = "absolute";
						img.style.top = "0";
						img.style.left = "0";

						panoCont.insertBefore(img, panoCont.firstChild.nextSibling);
					}

					resolve({});
				}, () => {});
			}
		} else if (Scene.isM3dActive()) {
			const img = node("img", { id: "m3dPrintImg", src: Scene.get3dScreenshot(false).src, crossOrigin: "anonymous" });

			img.style.position = "absolute";
			img.style.top = "0";
			img.style.left = "0";

			Scene.getContainer().appendChild(img);
			resolve({});
		} else {
			resolve({});
		}
	});
}

function downloadAsImageRemoveLoader() {
	Mapy.getComponent("print").returnAfterPrint();

	if (Mapy.getComponent("loader").getBigCon().parentNode === document.body) {
		Mapy.getComponent("loader").getBigCon().remove();
	}

	Mapy.getComponent("loader").end(true);
}

export async function downloadAsImage() {
	// add loader
	document.body.appendChild(Mapy.getComponent("loader").getBigCon());
	Mapy.getComponent("loader").start(true);
	Mapy.getComponent("print").prepare(4);

	try {
		await prepareImage();
		const imgData = await htmlToImage();

		if (Mapy.getComponent("pano").isActive()) {
			const panoImgReplace = document.getElementById("panoPrintImg");

			panoImgReplace?.remove();
		}

		if (Scene.isM3dActive()) {
			const m3dImg = document.getElementById("m3dPrintImg");

			if (m3dImg) {
				m3dImg.remove();
			}
		}

		downloadAsImageRemoveLoader();
		Mapy.Util.startBlobDownload(Mapy.Util.dataURItoBlob(imgData), "mapy.png");
	} catch (exc) {
		/* eslint-disable no-console */
		console.log(exc);
		downloadAsImageRemoveLoader();
	}
}
